<script setup lang="ts">
import { computed } from 'vue'

import type { KanbanComment } from '@entities/kanban-comment'

import { KanbanComments } from '@widgets/kanban-comments'
import { useOnTimezoneChange } from '@entities/viewer'

import { useCommentsApi } from '../api/comments.hook'
import { useSaveCommentApi } from '../api/save-comment.hook'
import { useUpdateCommentApi } from '../api/update-comment.hook'

defineOptions({
  name: 'TutorKanbanCommentsPage',
})

const route = useRoute()
const tutorId = computed<string>(() => route.params.id as string)

useOnTimezoneChange(() => {
  void useCommentsApi({ tutorId: tutorId.value })
})

const saveCommentApi = (comment: string): Promise<KanbanComment | null> =>
  useSaveCommentApi({ tutorId: tutorId.value, comment })

const updateCommentApi = (commentId: number, comment: string): Promise<KanbanComment | null> =>
  useUpdateCommentApi({ tutorId: tutorId.value, commentId, comment })
</script>

<template>
  <KanbanComments
    :save-api="saveCommentApi"
    :update-api="updateCommentApi"
  />
</template>
